import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactEcharts from "echarts-for-react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Sidebar } from "primereact/sidebar";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TopNav from "../components/common/topnav.component";
import downvector from '../assets/images/DownVector.svg';
import LoaderContainer from "../components/LoaderContainer/LoaderContainer";
import AppliedFilters from "../components/filterComponent/AppliedFilters";
import TopLinesChart from "./Annualplandashboard/charts/toplineschart";
import Horizontalbar from "./Annualplandashboard/charts/horizontalbar";
import DoubleLineChart from "./Annualplandashboard/charts/doublelinechart";
import SingleLineChart from "./Annualplandashboard/charts/singlelinechart";
import StackedBarChart from "./Annualplandashboard/charts/stackedbarchart";
import MultipleBarChart from "./Annualplandashboard/charts/multiplebarchart";
import { color } from "echarts";
import AttendanceSideBar from "./Annualplandashboard/popups/attendancesidebar";
import AttendanceSideBar2 from "./Annualplandashboard/popups/attendancesidebar2";
import { fetchAbsence_by_Building, fetchAttendance_Rate_Distribution, fetchAttendance_Rate_Distribution_Dimension, fetchChronic_Absence_Trend, fetchMonthly_Attendance_Rate_Trend, fetchOverall_Avg_Attendance_Rate, fetchPer_of_Students_Absent_Days, fetchSchool_Performance_Attendance, fetchSchools_with_Low_Attendance_Rate, fetchStudent_Absence_Reason, fetchStudent_Absentees, fetchStudent_Absentees_Trend, fetchStudents_Moving_in_and_out } from "../redux/slices/attendance";
import AttendanceBottomBar1 from "./Annualplandashboard/popups/attendancebottombar1";
import AttendanceBottomBar2 from "./Annualplandashboard/popups/attendancebottombar2";
import AttendanceBottomBar from "./Annualplandashboard/popups/attendancebottombar";
import ValueTooltip from "../components/Tooltip/valueTooltip";
import Edvisiondarklogo from '../assets/images/edvision-logo-dark.svg';

export default function Attendance(){
    const [activeTab, setActiveTab] = useState(0);
    /* Redux State */
    const dispatch = useDispatch();
    const Overall_Avg_Attendance_Rate = useSelector(state => state.attendance.Overall_Avg_Attendance_Rate);
    const Overall_Avg_Attendance_RateLoading = useSelector(state => state.attendance.Overall_Avg_Attendance_Rateloading);
    const School_Performance_Attendance = useSelector(state => state.attendance.School_Performance_Attendance);
    const School_Performance_AttendanceLoading = useSelector(state => state.attendance.School_Performance_Attendanceloading);
    const Monthly_Attendance_Rate_Trend = useSelector(state => state.attendance.Monthly_Attendance_Rate_Trend);
    const Monthly_Attendance_Rate_TrendLoading = useSelector(state => state.attendance.Monthly_Attendance_Rate_Trendloading);
    const Schools_with_Low_Attendance_Rate = useSelector(state => state.attendance.Schools_with_Low_Attendance_Rate);
    const Schools_with_Low_Attendance_RateLoading = useSelector(state => state.attendance.Schools_with_Low_Attendance_Rateloading);
    const Attendance_Rate_Distribution = useSelector(state => state.attendance.Attendance_Rate_Distribution);
    const Attendance_Rate_DistributionLoading = useSelector(state => state.attendance.Attendance_Rate_Distributionloading);
    const Per_of_Students_Absent_Days = useSelector(state => state.attendance.Per_of_Students_Absent_Days);
    const Per_of_Students_Absent_DaysLoading = useSelector(state => state.attendance.Per_of_Students_Absent_Daysloading);
    const Attendance_Rate_Distribution_Dimension = useSelector(state => state.attendance.Attendance_Rate_Distribution_Dimension);
    const Attendance_Rate_Distribution_DimensionLoading = useSelector(state => state.attendance.Attendance_Rate_Distribution_Dimensionloading);
    const Students_Moving_in_and_out = useSelector(state => state.attendance.Students_Moving_in_and_out);
    const Students_Moving_in_and_outLoading = useSelector(state => state.attendance.Students_Moving_in_and_outloading);
    const Chronic_Absence_Trend = useSelector(state => state.attendance.Chronic_Absence_Trend);
    const Chronic_Absence_TrendLoading = useSelector(state => state.attendance.Chronic_Absence_Trendloading);
    const Student_Absentees = useSelector(state => state.attendance.Student_Absentees);
    const Student_AbsenteesLoading = useSelector(state => state.attendance.Student_Absenteesloading);
    const Student_Absence_Reason = useSelector(state => state.attendance.Student_Absence_Reason);
    const Student_Absence_ReasonLoading = useSelector(state => state.attendance.Student_Absence_Reasonloading);
    const Student_Absentees_Trend = useSelector(state => state.attendance.Student_Absentees_Trend);
    const Student_Absentees_TrendLoading = useSelector(state => state.attendance.Student_Absentees_Trendloading);
    const Absence_by_Building = useSelector(state => state.attendance.Absence_by_Building);
    const Absence_by_BuildingLoading = useSelector(state => state.attendance.Absence_by_Buildingloading);

    const appliedfilter = useSelector(state => state.filter.appliedFilters);   
    /* */

    /* API Calls */
    useEffect(() => {
        dispatch(fetchOverall_Avg_Attendance_Rate({
            "elasticQueryName": "Overall Avg Attendance Rate",
            "filters": appliedfilter?.filter(itr => itr?.columnName != 'SCHOOL_YEAR'),
            "dynamicColumns": [],
        }));

        dispatch(fetchSchool_Performance_Attendance({
            "elasticQueryName": "School Performance-Attendance",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchMonthly_Attendance_Rate_Trend({
            "elasticQueryName": "Monthly_Attendance_Rate_Trend",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchSchools_with_Low_Attendance_Rate({
            "elasticQueryName": "Schools with Low Attendance Rate",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchAttendance_Rate_Distribution({
            "elasticQueryName": "Attendance Rate Distribution",
            "filters": appliedfilter?.filter(itr => itr?.columnName != 'SCHOOL_YEAR'),
            "dynamicColumns": [],
        }));

        dispatch(fetchPer_of_Students_Absent_Days({
            "elasticQueryName": "% of Students Absent Days",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchStudents_Moving_in_and_out({
            "elasticQueryName": "Students Moving in and out of Chronic",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchChronic_Absence_Trend({
            "elasticQueryName": "Chronic Absence Trend",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));
        /* Toptile Queries */ 
        dispatch(fetchStudent_Absentees({
            "elasticQueryName": "Student_Absentees",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchStudent_Absence_Reason({
            "elasticQueryName": "Student Absence Reason",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchStudent_Absentees_Trend({
            "elasticQueryName": "Student Absentees Trend",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));

        dispatch(fetchAbsence_by_Building({
            "elasticQueryName": "Absence_by_Building",
            "filters": appliedfilter,
            "dynamicColumns": [],
        }));
        /* End */ 
    }, [appliedfilter])

    useEffect(() => { 
        dispatch(fetchAttendance_Rate_Distribution_Dimension({
            "elasticQueryName": "Attendance Rate Distribution_Dimension",
            "filters": appliedfilter,
            "dynamicColumns": [{ "columnName": "#{dimension}", "columnValue": TabOption[activeTab]?.code}],
        })); 
    }, [appliedfilter, activeTab])
    /* */

    const [isSideBarVisible, setSideBarVisible] = useState(false);
    const [dropdownData, setDropdownData] = useState({selectedState: "", option: []});
    const [sideBarData, setSideBarData] = useState({ title: "", value: {} });
    const [isSideBar2Visible, setSideBar2Visible] = useState(false);

    const [isBottomBarVisible, setBottomBarVisible] = useState(false);
    const [isBottomBar1Visible, setBottomBar1Visible] = useState(false);
    const [isBottomBar2Visible, setBottomBar2Visible] = useState(false);
    const [selectedTitle, setSelectedTitle] = useState('');

    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const StudentAbsents = {
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },
            confine: true,
            formatter: function (params) {
                let tooltipText = `${params[0].name}<br/>`;
                params.forEach(item => {
                    let valueFormat = item.seriesName === '% of Students'
                        ? `${item.value?.toFixed(1)}%`
                        : item.value.toLocaleString(); // Format numbers with commas

                    tooltipText += `
                    <div class="flex items-center py-[3px] justify-between w-full">
                        <span class="flex items-center">
                            <span class="inline-block mr-1 rounded-full w-2.5 h-2.5" style="background-color: ${item.color};"></span>
                            ${item.seriesName}
                        </span>
                        <span class="ml-2">${valueFormat}</span>
                    </div>
                  `;
                });
                return tooltipText;
            }
        },
        grid: {
            left: '3%',
            bottom: '-10%',
            top: "-10%",
            right: '15%',
            // height: '100%',
            containLabel: true
        },
        legend: {
            show: false,
            bottom: "0",
            left: '0',
            itemGap: 4,
            itemWidth: 7,
            itemHeight: 7,
        },
        yAxis: [
            {
                type: 'category',
                // position: "left",
                inverse: true,
                // data: ['0-5 Days', '6-10 Days', '11-15 Days', '16 Days or more'],
                data: Per_of_Students_Absent_Days?.map(item => item?.CATEGORY),
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: '12',
                    fontWeight: 100,
                    // position: 'insideLeft',
                },
                axisTick: {
                    show: false,
                },
            },
        ],

        xAxis: [
            {
                show: false,
                inverse: false,
            },
            {
                show: false,
                min:0,
                max:100,
            }
        ],

        series: [
            {
                name: "# of Students",
                // data: [2000,2000,2000,2000],
                data: Per_of_Students_Absent_Days?.map(item => item?.VALUE),
                type: 'bar',
                xAxisIndex: 0,  // down x-axis
                barWidth: '75%',  
                itemStyle: {
                    color: "#D46C58",
                    borderRadius: [0, 2, 2, 0],
                },
                label: {
                    show: true,
                    position: 'right',
                    formatter: params => params.value?.toLocaleString(),
                    textStyle: {
                        color: "#fff",
                        fontSize: 10,
                    },
                    // offset: [10, 0],
                },

                z: 1,  
            },
            {
                name: '% of Students',
                // data: [1500, 1200, 1700, 800],
                data: Per_of_Students_Absent_Days?.map(item => item?.PERCENTAGE),
                type: 'bar',
                xAxisIndex: 1,    // top x-axis
                barGap: '-80%',  
                barWidth: '50%', 
                itemStyle: {
                    color: "#EA9E50",
                    borderRadius: [0, 2, 2, 0],
                },
                label: {
                    show: true,
                    position: 'insideLeft',
                    formatter: params => params.value?.toFixed(1) + '%',
                    textStyle: {
                        color: "#2C363F",
                        fontSize: 10,
                        padding: [0, 0, 0, 0],
                    },
                },
                z: 2,  // Higher z-index to be on top of the total population
            },

        ],

    };

    const LowAttendanceMonth = {
        tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },
            // valueFormatter: value => value?.toFixed(1)+'%',
            formatter: (params) => {
                return `${params?.marker} <b>${params?.name}</b>: ${params?.value?.toFixed(1)}% (${params?.data?.NUMERIC_VALUE?.toFixed(0)})`
            },
            confine: true,
        },
        legend: {
            show: true,
            bottom: 10,
            left: '10',
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
                color: "#E0E3E9",
                fontSize: 10,
            }
        },
        grid: {
            left: '3%',
            bottom: '15%',
            top: "3%",
            right: '35',
            containLabel: true
        },

        yAxis: [
            {
                type: 'category',
                position: "left",
                inverse: true,
                // data: ['School E', 'School D', 'School C', 'School B', 'School A'],
                data: Schools_with_Low_Attendance_Rate?.map(item => item?.SCHOOL_OFFICIAL_NAME),
                axisLine: {
                    show: true,
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: '12',
                    fontWeight: "normal",
                    formatter: function (value) {
                        const maxLen = 22; // set max length
                        return value.length > maxLen ? value.slice(0, maxLen) + '...' : value;
                    },
                    position: 'insideLeft',
                },
                axisTick: {
                    show: false,
                },
            },
        ],

        xAxis: {
            show: true,
            type: "value",
            splitLine: {
                show: true,
                lineStyle: {
                    type: "dashed",
                    color: '#42536D'
                },
            },
            axisLine: { show: true },
            axisTick: { show: false },
            axisLabel: {
                color: "#D6D6D6",
                fontSize: 12,
                overflow: "break",
                interval: 0,
            },
        },

        series: [
            {
                name: "Attendance Rate (%)",
                // data: [89.0, 87.8, 89.3, 88.5, 88.8],
                data: Schools_with_Low_Attendance_Rate?.map(item => ({
                    value: item?.PERCENTAGE,
                    ...item
                })),
                type: 'bar',
                barWidth: '75%',  
                itemStyle: {
                    color: "#B55D5D",
                    borderRadius: [0, 4, 4, 0],
                },
                label: {
                    show: true,
                    position: 'right',
                    formatter: params => params.value?.toFixed(1) + '%',
                    textStyle: {
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: "normal",
                    },
                    offset: [10, 0],
                },

                z: 1,  
            },
        ],
    };

    const Barcolor = ['#B65D59', '#129C83']
    const StudentsMoveInOut = {
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },
            formatter:(params) => {
                return `
                        <b>${params?.[0]?.axisValueLabel}</b><br/> 
                        <div class="flex items-center py-[3px]">
                            <span class="flex items-center font-extrabold">
                                <span class="inline-block mr-1 rounded-full w-2.5 h-2.5" style="background-color: ${params?.[0]?.color};"></span>
                                ${params?.[0]?.seriesName}
                            </span>
                            <span class="ml-2 font-extrabold">${params?.[0]?.value} (${params?.[0]?.data?.PERCENTAGE?.toFixed(1)}%)</span>
                        </div>
                        <div class="w-[10rem] text-wrap">
                            ${params?.[0]?.axisValueLabel == 'Student Moving In' 
                            ? 'Number of students who entered the chronic absenteeism category during the reporting period.' 
                            : 'Number of students who improved their attendance and exited the chronic absenteeism category.'}
                        </div>
                    `;
            },
            confine: true,
        },
        legend: {
            // show: true,
            data: ["Students Moving in", "Students Moving out"],
            bottom: 10,
            left: '10',
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
                color: "#E0E3E9",
                fontSize: 10,
            }
        },
        grid: {
            left: '7%',
            bottom: '15%',
            top: "5%",
            right: '20',
            containLabel: true
        },
        xAxis: {
            show: true,
            type: 'category',
            // data: ['Students Moving in', 'Students Moving out'],
            data: Students_Moving_in_and_out?.map(item => item?.INCIDENT_TYPE),
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#42536D",
                }
            },
            axisLabel: {
                color: "#E0E3E9",
                fontSize: 12,
            },
        },
        yAxis: {
            type: "value",
            show: true,
            // data: [0, 100, 200, 300, 40],
            axisLabel: {
                color: "#E0E3E9",
                fontSize: 12,
            },
            name: "# of students",
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 45,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            // min: 0,
            // max: 500,
            splitLine: {
                show: true,
                lineStyle: {
                    type: "dashed",
                    color: "#42536D",
                    width: 1
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#42536D"
                }
            },
        },
        series: [
            {
                name: "Students",
                type: 'bar',
                barWidth: "70%",
                // data: [
                //     {
                //       value: 350,
                //       itemStyle: { color: "#C79B27" }, // Gold
                //       name: "Students Moving in"
                //     },
                //     {
                //       value: 200,
                //       itemStyle: { color: "#D46C58" }, // Red
                //       name: "Students Moving out"
                //     }
                //   ],
                data: Students_Moving_in_and_out?.map((item, i) => {
                    return {
                        value: item?.VALUE,
                        itemStyle: { color: Barcolor[i] },
                        name: item?.INCIDENT_TYPE,
                        ...item
                    }
                }),
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 12,
                    color: '#E0E3E9',
                    formatter: ({ value }) => value ?? ''
                },
                // itemStyle: {
                //     color: "#C79B27",
                //     borderRadius: [2, 2, 0, 0],
                // },
            },
        ],
    }

    /* Dropdown Data set.. */
    const HandleSelectTileDrp = (data) => {
        /* DropDown Option */
        const dropdownOptions = data.map((school) => ({
            label: school,
            value: school
        }));
        /* */
        setDropdownData({ selectedState: data[0], option: dropdownOptions })
    }
    /* */

    /* Overall Avg Attendance Rate Toptile.. */
    const Overall_Avg_Attendance_RateCYData = Overall_Avg_Attendance_Rate?.filter(itr => itr?.SCHOOL_YEAR == 2025)
    /* */

    const HandleSelectTile = (title, value) => {
        setSideBarData({ title: title, value: value })
    }
    /* School Performance Tile Data Processed */
    const SchoolPerformanceAttendance = School_Performance_Attendance?.filter(itr => itr?.METRIC_ID == 10003)
    const SchoolPerformanceChronic = School_Performance_Attendance?.filter(itr => itr?.METRIC_ID == 10002)
    /*  */

    /* Tab Change */
    const TabOption = {
        0 : {name: 'Grade', code: 'student_grade'},
        1 : {name: 'Ethnicity', code: 'student_ethnicity'},
        2 : {name: 'Gender', code: 'student_gender'},
        3 : {name: 'School Type', code: 'school_type'},
        4 : {name: 'Building', code: 'School_official_name'},
    }
    /*  */

    /* Last 7 Days Formated Data */
    const Absentees_TrendData = Student_Absentees_Trend.map(item => {
        const [year, month, day] = item.INCIDENT_TIME.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        const dayPart = date.getDate(); // 1-31
        const monthPart = date.toLocaleString('en-US', { month: 'short' }); // Jan, Feb, etc.
        const dayName = date.toLocaleDateString('en-US', { weekday: 'short' }); // Mon, Tue, etc.
        return {
            ...item,
            INCIDENT_TIME: `${dayPart} ${monthPart}`
        };
    });
    /* */

    /* Tooltip Description */
    const TooltipAttributes = ({ categorydescription }) => {
        return {
            'data-pr-tooltip': `${categorydescription}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            'data-pr-className': 'custom-tooltip',
            style: { cursor: 'pointer' }
        }
    }
    /*  */

    return(
        <>
            <div className="body staffbg">
                <TopNav pagename="Student Attendance" pagenamedescription="Key facts about Attendance" />
                <AppliedFilters pagename={"Attendance"}/>
                <div className="px-[20px] lg:px-[40px] mb-5">
                    {/* Old Design */}
                    {/* <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px] cursor-pointer h-full" onClick={() => {setSideBarVisible(true); HandleSelectTile('Avg Attendance Rate', Overall_Avg_Attendance_Rate?.[0])}}>
                                <div className="flex justify-between items-center mb-3">
                                    <div className="text-[16px] toptile_head text-[#D6D6D6] leading-[18px] ">Avg Attendance Rate </div>
                                    <div className="flex gap-2">
                                        <div className="text-white">{Overall_Avg_Attendance_RateCYData?.[0]?.TARGET_NUMERATOR}%</div>
                                        {Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE == 0 ?
                                                    <div className="bg-[#db685b] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE < 0 ?
                                                    <div className="bg-[#db685b] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE?.toFixed(1)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    <div className="bg-[#129C83] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE?.toFixed(1)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                            }
                                    </div>
                                </div>
                                <div className="h-[100px]">
                                    <LoaderContainer loading={Overall_Avg_Attendance_RateLoading} height={'100%'} width={'100%'}>
                                        <TopLinesChart
                                            tooltip={{
                                                trigger: 'axis',
                                                valueFormatter: (value) => value.toFixed(1)+'%',
                                                backgroundColor: 'rgba(50,50,50,0.7)',
                                                borderColor: "#333",
                                                textStyle: {
                                                    fontSize: 12,
                                                    fontWeight: "normal",
                                                    color: '#fff',
                                                },
                                                axisPointer: {
                                                    type: 'shadow'
                                                },
                                                confine: true,
                                            }}
                                            grid={{
                                                top: '5%',
                                                left: '12%',
                                                right: '0%',
                                                bottom: '20%',
                                                // containLabel: true,
                                            }}
                                            legend={{
                                                show: false,
                                                top: 'bottom',
                                                left: 'start',
                                                data: ['Shipping', 'Avg Per Month'],
                                                textStyle: {
                                                    color: '#828A91',
                                                    fontSize: 8
                                                }
                                            }}
                                            xaxisdata={Overall_Avg_Attendance_Rate?.map(item => item?.SCHOOL_YEAR)}
                                            // xaxisdata={Schools_With_High_Absentees.map(item => item?.SCHOOL_OFFICIAL_NAME)}
                                            xaxisLabel={{
                                                color: '#D6D6D6',
                                                formatter: function (value) {
                                                    return value.length > 5 ? value.substring(0, 5) + "..." : value;
                                                },
                                                fontSize: 12,
                                                interval: 0,
                                            }}
                                            xaxisLine={{ show: false }}
                                            xaxisTick={{ show: false }}

                                            // min={90}
                                            // max={95}
                                            // interval={10}
                                            yaxisLabel={{
                                                color: '#D6D6D6',
                                                fontSize: 12,
                                                formatter: '{value}%'
                                            }}
                                            yaxisLine={{
                                                lineStyle: {
                                                    color: '#FFFFFF',
                                                    type: 'dashed',
                                                },
                                            }}
                                            data={Overall_Avg_Attendance_Rate?.map(item => item?.ATTENDANCE_RATE)}
                                            // data={[34, 23, 20, 18, 15]}
                                            // data={Schools_With_High_Absentees.map(item => item?.METRIC_NUMERATOR)}
                                            barWidth={'80%'}
                                            itemStyle={{
                                                color: '#C79B27',
                                                borderRadius: [3, 3, 0, 0],
                                            }}
                                            label={{
                                                show: true,
                                                formatter: (params) => params.value?.toFixed(1)+'%',
                                                position: 'insideTop',
                                                color: '#fff',
                                                fontSize: 14,
                                                fontWeight: 400,
                                                padding: [0, 0, 0, 0],
                                            }}
                                            Zoom={true}
                                        />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px]" onClick={() => {setSideBarVisible(false); HandleSelectTile('Attendance Rate Distribution', Attendance_Rate_Distribution?.[0])}}>
                                <div className="text-[16px] toptile_head text-[#D6D6D6] leading-1 mb-3 capitalize">Attendance Rate Distribution</div>
                                <div className="h-[100px]">
                                    <LoaderContainer loading={Attendance_Rate_DistributionLoading} height={'100%'} width={'100%'}>
                                        <StackedBarChart
                                            grid={{
                                                left: "3%",
                                                right: "4%",
                                                bottom: "0%",
                                                top: "0%",
                                                containLabel: true
                                            }}
                                            legend={{
                                                data: ["90% - 94%", ">95%", "<90%"],
                                                bottom: "0",
                                                left: '0',
                                                padding: [0, 0, 0, 0],
                                                itemGap: 4,
                                                itemWidth: 7,
                                                itemHeight: 7,
                                                textStyle: {
                                                    color: '#fff',
                                                    fontSize: 10
                                                },
                                            }}
                                            xAxisData={{
                                                show: false,
                                                type: "value",
                                                max: 100,
                                                axisLine: { show: false },
                                                splitLine: { show: false },
                                            }}
                                            yAxisData={{
                                                type: "category",
                                                inverse: true,
                                                // data: ["2022", "2023", "2024"],
                                                data: Attendance_Rate_Distribution?.map(item => item?.SCHOOL_YEAR),
                                                axisLabel: {
                                                    show: true,
                                                    color: "#fff",
                                                    fontSize: 12,
                                                },
                                                axisLine: { show: false },
                                                splitLine: { show: false },
                                                axisTick: { show: false },
                                            }}
                                            series={[
                                                {
                                                    name: "<90%",
                                                    type: "bar",
                                                    stack: "total",
                                                    label: {
                                                        show: true,
                                                        position: "inside",
                                                        color: "#fff",
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        formatter: (params) => params?.value?.toFixed(1) + '%',
                                                        // formatter: "{c}%"
                                                    },
                                                    itemStyle: {
                                                        color: "#B65D59",
                                                        borderRadius: [5, 0, 0, 5],
                                                    },
                                                    // data: [56, 49, 56]
                                                    data: Attendance_Rate_Distribution?.map(item => item?.PCT_BELOW_90)
                                                },
                                                {
                                                    name: ">95%",
                                                    type: "bar",
                                                    stack: "total",
                                                    label: {
                                                        show: true,
                                                        position: "inside",
                                                        formatter: (params) => params?.value?.toFixed(1) + '%',
                                                        color: "#fff",
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        // formatter: "{c}%"
                                                    },
                                                    itemStyle: {
                                                        color: "#C79B27"
                                                    },
                                                    // data: [26, 26, 26]
                                                    data: Attendance_Rate_Distribution?.map(item => item?.PCT_ABOVE_95)
                                                },
                                                {
                                                    name: "90% - 94%",
                                                    type: "bar",
                                                    stack: "total",
                                                    label: {
                                                        show: true,
                                                        position: "inside",
                                                        color: "#fff",
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        formatter: (params) => params?.value?.toFixed(1) + '%',
                                                        // formatter: "{c}%"
                                                    },
                                                    itemStyle: {
                                                        color: "#129C83",
                                                        borderRadius: [0, 5, 5, 0],
                                                    },
                                                    //   data: [18, 26, 18]
                                                    data: Attendance_Rate_Distribution?.map(item => item?.PCT_90_94)
                                                }
                                            ]}
                                        />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px] cursor-pointer" onClick={() => {setSideBarVisible(true); HandleSelectTile('% of Students Absent Days', Per_of_Students_Absent_Days?.[0])}}>
                                <div className="text-[16px] text-[#D6D6D6] toptile_head leading-1 mb-3 capitalize">% of Students Absent Days</div>
                                <div className="h-[100px]">
                                    <LoaderContainer loading={Per_of_Students_Absent_DaysLoading} height={'100%'} width={'100%'}>
                                        <ReactEcharts option={StudentAbsents} style={{ width: '100%', height: '100%' }} />;
                                    </LoaderContainer>
                                    </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px] cursor-pointer" onClick={() => {setSideBarVisible(true); HandleSelectTile('Monthly Attendance Rate Trend', Monthly_Attendance_Rate_Trend?.[0]); HandleSelectTileDrp(Monthly_Attendance_Rate_Trend?.map(item => item?.MONTH))}}>
                                <div className="text-[16px] text-[#D6D6D6] toptile_head leading-[22px] mb-3 capitalize">Monthly Attendance Rate Trend</div>
                                <div className="h-[100px]">
                                    <LoaderContainer loading={Monthly_Attendance_Rate_TrendLoading} height={'100%'} width={'100%'}>
                                        <SingleLineChart
                                            grid={{
                                                top: '10%',
                                                left: '12%',
                                                right: '5%',
                                                bottom: '1%',
                                                containLabel: true,
                                            }}
                                            legend={{
                                                show: false,
                                                bottom: 2,
                                                padding: [0, 0, 0, 10],
                                                left: 'start',
                                                itemGap: 4,
                                                itemWidth: 7,
                                                itemHeight: 7,
                                                textStyle: {
                                                    color: '#d6d6d6',
                                                    fontSize: 10
                                                },
                                                data: ['Days'],
                                            }}
                                            data={Monthly_Attendance_Rate_Trend}
                                        />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* New Design */}
                    {/* <div className="top-wrap px-[20px] pb-3 mb-3"> */}
                        <div className="text-[#EEEEF0] text-[16px] text-left mb-2 pt-2 ">TODAY'S <span className="font-semibold">INSIGHTS</span> - {new Date().toLocaleDateString('en-US')}</div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px] cursor-pointer h-full" onClick={() => { setBottomBarVisible(true); setSelectedTitle('Absentees') }}>
                                    <Tooltip target=".custom-target-icon" />
                                    <div className="text-[16px] text-[#D6D6D6] leading-[18px] mb-3 w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: 'Total number of students who were absent during each day.' })}>Absentees</div>
                                    <div className="flex gap-[6px] items-center mb-[1rem]">
                                        <ValueTooltip heading="Absentees" value1={Student_Absentees?.[0]?.METRIC_NUMERATOR} value2={Student_Absentees?.[0]?.PERCENTAGE?.toFixed(1)+'%'}>
                                        <div className="text-[24px] 2xl:text-[36px] font-bold text-[#fff] leading-[36px]">{Student_Absentees?.[0]?.METRIC_NUMERATOR}</div>
                                        </ValueTooltip>
                                        {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 ">LY Var &nbsp; -% <img src={downvector} /></div> */}
                                        {Student_Absentees?.[0]?.LAST_VARIANCE == 0 || Student_Absentees?.[0]?.LAST_VARIANCE == null ?
                                            <div className="bg-[#db685b] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LD Var &nbsp; - % <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                            :
                                            Student_Absentees?.[0]?.LAST_VARIANCE < 0 ?
                                                <div className="bg-[#db685b] rounded-[25px] text-[11px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LD Var &nbsp; {Student_Absentees?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                :
                                                <div className="bg-[#129C83] rounded-[25px] text-[11px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LD Var &nbsp; {Student_Absentees?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px] cursor-pointer h-full" onClick={() => { setBottomBar1Visible(true); setSelectedTitle('Major Absence Reason') }}>
                                    <div className="text-[16px] text-[#D6D6D6] leading-[18px] mb-3 capitalize custom-target-icon w-fit" {...TooltipAttributes({ categorydescription: 'Most common reasons reported for student absences.' })}>Major Absence Reason</div>
                                    <div className="">
                                        <Horizontalbar
                                            tooltip={{
                                                show: true,
                                                trigger: 'item',
                                                axisPointer: {
                                                    type: 'shadow'
                                                },
                                                formatter: (params) => {
                                                    return `${params?.marker} <b>${params?.name}</b>: ${params?.value?.toFixed(0)} (${params?.data?.PERCENTAGE?.toFixed(1)}%)`
                                                },
                                                confine: true,
                                            }}
                                            grid={{
                                                top: '0%',
                                                left: '3%',
                                                right: '0%',
                                                bottom: '0%',
                                                containLabel: true,
                                            }}
                                            legend={{
                                                show: false,
                                                bottom: 0,
                                                padding: [0, 0, 0, 20],
                                                left: 'start',
                                                itemGap: 4,
                                                itemWidth: 7,
                                                itemHeight: 7,
                                                textStyle: {
                                                    color: '#828A91',
                                                    fontSize: 7
                                                },
                                                data: ['Staff'],
                                            }}
                                            xAxis={{
                                                type: 'value',
                                                // min: 0,
                                                // max: 500,
                                                boundaryGap: [0, 0.01],
                                                splitLine: {
                                                    show: false
                                                },
                                                axisLabel: {
                                                    show: false
                                                }
                                            }}
                                            yAxis={{
                                                type: 'category',
                                                data: Student_Absence_Reason?.map(item => item?.INCIDENT_TYPE),
                                                // data: ['Family Illness', 'Personal Day', 'Personal Illness'],
                                                axisLabel: {
                                                    show: true,
                                                    color: '#D6D6D6',
                                                    fontSize: 12,
                                                },
                                                axisLine: {
                                                    show: false
                                                },
                                                axisTick: {
                                                    show: false
                                                },
                                            }}
                                            name={'Staff'}
                                            type='bar'
                                            barWidth={'86%'}
                                            itemStyle={{
                                                color: '#79543A',
                                                barBorderRadius: [0, 4, 4, 0]
                                            }}
                                            // data={[30, 40, 50]}
                                            data={Student_Absence_Reason?.map(item => ({
                                                value:item?.METRIC_NUMERATOR,
                                                ...item
                                            })
                                            )}
                                            label={{
                                                show: true,
                                                position: 'insideRight',
                                                color: '#fff',
                                                fontSize: 14,
                                                fontWeight: 400,
                                                align: 'right'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px] cursor-pointer h-full" onClick={() => { setBottomBar2Visible(true); setSelectedTitle('Last 7 Days Absentees Trend') }}>
                                    <div className="text-[16px] text-[#D6D6D6] leading-[18px] mb-3 capitalize custom-target-icon w-fit" {...TooltipAttributes({ categorydescription: 'A weekly trend showing student absences over the last 7 days.' })}>Last 7 Days Absentees Trend</div>
                                    <div className="">
                                        <DoubleLineChart 
                                        tooltip={{
                                            show: true,
                                            formatter: (params) => {
                                                return `${params?.marker}<b> ${params?.name}:</b> ${params?.data?.METRIC_NUMERATOR?.toFixed(0)} (${params?.data?.PERCENTAGE?.toFixed(1)}%)`
                                            },
                                        }}
                                        data={Absentees_TrendData} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3">
                                <div className="top-tile bg-[#0F0D0B] p-3 rounded-[6px] cursor-pointer h-full" onClick={() => { setBottomBar1Visible(true); setSelectedTitle('Absence by Building') }}>
                                    <div className="text-[16px] text-[#D6D6D6] leading-[18px] mb-3 capitalize custom-target-icon w-fit" {...TooltipAttributes({ categorydescription: 'Total number of student absences recorded each day across all school buildings.' })}>Absence by Building</div>
                                    <div className="h-[100px]">
                                        <TopLinesChart
                                            tooltip={{
                                                show: true,
                                                trigger: 'item',
                                                axisPointer: {
                                                    type: 'shadow'
                                                },
                                                formatter: (params) => {
                                                    return `${params?.marker} <b>${params?.name}</b>: ${params?.value?.toFixed(0)} (${params?.data?.PERCENTAGE?.toFixed(1)}%)`
                                                },
                                                confine: true,
                                            }}
                                            grid={{
                                                top: '5%',
                                                left: '0%',
                                                right: '0%',
                                                bottom: '20%',
                                                // containLabel: true,
                                            }}
                                            yaxis={false}
                                            legend={{
                                                show: false,
                                                top: 'bottom',
                                                left: 'start',
                                                data: ['Shipping', 'Avg Per Month'],
                                                textStyle: {
                                                    color: '#828A91',
                                                    fontSize: 8
                                                }
                                            }}
                                            // xaxisdata={['School A', 'School B', 'School C', 'School D', 'School D']}
                                            xaxisdata={Absence_by_Building.map(item => item?.SCHOOL_OFFICIAL_NAME)}
                                            xaxisLabel={{
                                                color: '#D6D6D6',
                                                formatter: function (value) {
                                                    return value.length > 10 ? value.substring(0, 8) + "..." : value;
                                                },
                                                fontSize: 12,
                                                interval: 0,
                                            }}
                                            xaxisLine={{ show: false }}
                                            xaxisTick={{ show: false }}

                                            // min={0}
                                            // max={40}
                                            // interval={1}
                                            yaxisLabel={{
                                                color: '#D6D6D6',
                                                fontSize: 12,
                                            }}
                                            yaxisLine={{
                                                lineStyle: {
                                                    color: '#FFFFFF',
                                                    type: 'dashed',
                                                },
                                            }}
                                            // data={[34, 23, 20, 18, 15]}
                                            data={Absence_by_Building.map(item => ({
                                                value: item?.TOTAL_METRIC,
                                                ...item
                                            })
                                            )}
                                            barWidth={'80%'}
                                            itemStyle={{
                                                color: '#79543A',
                                                borderRadius: [3, 3, 0, 0],
                                            }}
                                            label={{
                                                show: true,
                                                position: 'inside',
                                                color: '#fff',
                                                fontSize: 12,
                                                fontWeight: 400,
                                                padding: [0, 0, 0, 0],
                                            }}
                                            Zoom={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/* </div> */}
                </div>
                <div className="px-[20px] lg:px-[40px] pb-5">
                    <div className="grid grid-cols-12 gap-5">
                        <div className="col-span-12 lg:col-span-4">
                            <div className="bg-[#272321e6] rounded-[6px] border border-[#ffffff1a] cursor-pointer " onClick={() => {setSideBarVisible(true); HandleSelectTile(`Schools with Low Attendance Rate in Past (${Schools_with_Low_Attendance_Rate?.[0]?.MONTH})`, Schools_with_Low_Attendance_Rate?.[0]); HandleSelectTileDrp(Schools_with_Low_Attendance_Rate?.map(item => item?.SCHOOL_OFFICIAL_NAME))}}>
                                <div className="px-4 py-3 text-[16px] text-[#fff] border-b border-[#ffffff1a] w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: 'List of schools where attendance rates were consistently low in the last month.' })}>Schools with Low Attendance Rate in Past ({Schools_with_Low_Attendance_Rate?.[0]?.MONTH})</div>
                                <div className="h-[300px]">
                                    <LoaderContainer loading={Schools_with_Low_Attendance_RateLoading} height={'100%'} width={'100%'}>
                                        {/* <CustChart options={LowAttendanceMonth} /> */}
                                        <ReactEcharts option={LowAttendanceMonth} style={{ width: '100%', height: '100%' }} />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-4">
                            <div className="bg-[#272321e6] rounded-[6px] border border-[#ffffff1a] ">
                                <div className="px-4 py-3 text-[16px] text-[#fff] border-b border-[#ffffff1a] w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: Chronic_Absence_Trend?.[0]?.METRIC_DESCRIPTION })}>Chronic Absence Trend</div>
                                <div className="h-[300px]">
                                    <LoaderContainer loading={Chronic_Absence_TrendLoading} height={ '100%' } width={ '100%' }>
                                        <MultipleBarChart data={Chronic_Absence_Trend} />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-4">
                            <div className="bg-[#272321e6] rounded-[6px] border border-[#ffffff1a] cursor-pointer " onClick={() => setSideBar2Visible(true)}>
                                <div className="px-4 py-3 text-[16px] text-[#fff] border-b border-[#ffffff1a] w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: Students_Moving_in_and_out?.[0]?.METRIC_DESCRIPTION })}># of Students Moving in and out of Chronic Absence</div>
                                <div className="h-[300px]">
                                    <LoaderContainer loading={Students_Moving_in_and_outLoading} height={'100%'} width={'100%'}>
                                        {/* <CustChart options={StudentsMoveInOut} /> */}
                                        <ReactEcharts option={StudentsMoveInOut} style={{ width: '100%', height: '100%' }} />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OLD */}
                {/* <div className="px-[40px] pb-5">
                    <div className="grid grid-cols-12 gap-5">
                        <div className="col-span-12 md:col-span-6">
                            <div className="bg-[#272321e6] rounded-[6px] border border-[#ffffff1a] p-2 ">
                                <div className="px-3 py-2 text-[16px] text-[#fff] font-medium ">School Performance</div>
                                <div className="grid grid-cols-12">
                                    <div className="col-span-12 md:col-span-6">
                                        <div className="text-center text-[16px] text-[#fff] font-medium pb-2 ">Attendance Rate</div>
                                        <LoaderContainer loading={School_Performance_AttendanceLoading} height={'95%'} width={'100%'}>
                                            <DataTable className="attend_table" value={SchoolPerformanceAttendance} scrollable
                                                scrollHeight="420px" stripedRows tableStyle={{ maxWidth: '100%', minHeight: '420px' }}>
                                                <Column field="SCHOOL_OFFICIAL_NAME" header="School Name" sortable style={{}} body={schoolNameTemplate}></Column>
                                                <Column field="ATTENDANCE_RATE" className="text-center" header="Attendance Rate" sortable style={{}} body={(rowData) => `${rowData.ATTENDANCE_RATE?.toFixed(1)}%`}></Column>
                                            </DataTable>
                                        </LoaderContainer>
                                    </div>
                                    <div className="col-span-12 md:col-span-6">
                                        <div className="text-center text-[16px] text-[#fff] font-medium pb-2 ">Chronic Absence Rate</div>
                                        <LoaderContainer loading={School_Performance_AttendanceLoading} height={'95%'} width={'100%'}>
                                            <DataTable className="attend_table" value={SchoolPerformanceChronic} scrollable scrollHeight="420px" stripedRows tableStyle={{ maxWidth: '100%', minHeight: '420px' }}>
                                                <Column field="SCHOOL_OFFICIAL_NAME" header="School Name" sortable style={{}} body={schoolNameTemplate}></Column>
                                                <Column field="ATTENDANCE_RATE" className="text-center" header="Chronic Absence Rate" sortable style={{}} body={(rowData) => `${rowData.ATTENDANCE_RATE?.toFixed(1)}%`}></Column>
                                            </DataTable>
                                        </LoaderContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6">
                            <div className="bg-[#272321e6] rounded-[6px] border border-[#ffffff1a]">
                                <div className="px-3 py-2 text-[16px] text-[#fff] font-medium border-b border-[#ffffff1a]">{TabOption[activeTab]?.name} - Wise Attendance Rate Distribution</div>
                                <div className="px-4 mb-2">
                                    <Tabs selectedIndex={activeTab} onSelect={handleTabClick}>
                                        <TabList>
                                            <div className="flex items-center mb-1">
                                                <Tab>
                                                    <div className={`${ activeTab === 0 ? " bg-[#4c3428]" : " bg-[#141110]" } text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-bl-[5px] cursor-pointer `}>Grade</div>
                                                </Tab>
                                                <Tab>
                                                    <div className={`${ activeTab === 1 ? " bg-[#4c3428]" : " bg-[#141110]" } text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] cursor-pointer `}>Ethnicity</div>
                                                </Tab>
                                                <Tab>
                                                    <div className={`${ activeTab === 2 ? " bg-[#4c3428]" : " bg-[#141110]" } text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] cursor-pointer `}>Gender</div>
                                                </Tab>
                                                <Tab>
                                                    <div className={`${ activeTab === 3 ? " bg-[#4c3428]" : " bg-[#141110]" } text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-br-[5px] cursor-pointer `}>School Type</div>
                                                </Tab>
                                            </div>
                                        </TabList>
                                        <div className="h-[420px]">
                                            <LoaderContainer loading={Attendance_Rate_Distribution_DimensionLoading} height={'100%'} width={'100%'}>
                                                <StackedBarChart
                                                    grid={{
                                                        left: "2%",
                                                        right: "4%",
                                                        bottom: "0%",
                                                        top: "3%",
                                                        containLabel: true
                                                    }}
                                                    legend={{
                                                        data: ['<90%', '90%-94%', '>95%'],
                                                        bottom: 0,
                                                        left: 'start',
                                                        padding: [0, 0, 0, 10],
                                                        itemGap: 4,
                                                        itemWidth: 7,
                                                        itemHeight: 7,
                                                        textStyle: {
                                                            color: '#E0E3E9',
                                                            fontSize: 10
                                                        },
                                                    }}
                                                    xAxisData={{
                                                        show: false,
                                                        type: "value",
                                                        // max: 100,
                                                        axisLine: { show: false },
                                                        splitLine: { show: false },
                                                    }}
                                                    yAxisData={{
                                                        type: "category",
                                                        inverse: true,
                                                        // data: [
                                                        //     'Pre-K', 'KG', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'
                                                        //   ],
                                                        data: Attendance_Rate_Distribution_Dimension?.map(item => item?.DIMENSION),
                                                        axisLabel: {
                                                            show: true,
                                                            color: "#E0E3E9",
                                                            fontSize: 12,
                                                        },
                                                        axisLine: { show: false },
                                                        splitLine: { show: false },
                                                        axisTick: { show: false },
                                                    }}
                                                    series={[
                                                        {
                                                            name: "<90%",
                                                            type: "bar",
                                                            stack: "total",
                                                            label: {
                                                                show: true,
                                                                position: 'inside',
                                                                color: "#fff",
                                                                fontSize: 12,
                                                                fontWeight: 500,
                                                                // formatter: "{c}%"
                                                                formatter: (params) => params?.value < 1 ? '' : (params?.value?.toFixed(1) + '%'),
                                                            },
                                                            itemStyle: {
                                                                color: "#B65D59",
                                                                borderRadius: [0, 0, 0, 0],
                                                            },
                                                            // data: [65, 58, 67, 60, 66, 65, 66, 65, 56, 62, 66, 66, 65, 68],
                                                            data: Attendance_Rate_Distribution_Dimension?.map(item => item?.PCT_BELOW_90),
                                                        },
                                                        {
                                                            name: "90%-94%",
                                                            type: "bar",
                                                            stack: "total",
                                                            label: {
                                                                show: true,
                                                                position: "inside",
                                                                color: "#fff",
                                                                fontSize: 12,
                                                                fontWeight: 500,
                                                                // formatter: "{c}%"
                                                                formatter: (params) => params?.value < 1 ? '' : (params?.value?.toFixed(1) + '%'),
                                                            },
                                                            itemStyle: {
                                                                color: "#C79B27"
                                                            },
                                                            // data: [24, 27, 21, 17, 17, 22, 22, 21, 20, 25, 20, 20, 22, 20],
                                                            data: Attendance_Rate_Distribution_Dimension?.map(item => item?.PCT_90_94),
                                                        },
                                                        {
                                                            name: ">95%",
                                                            type: "bar",
                                                            stack: "total",
                                                            label: {
                                                                show: true,
                                                                position: "inside",
                                                                color: "#fff",
                                                                fontSize: 12,
                                                                fontWeight: 500,
                                                                // formatter: "{c}%"
                                                                formatter: (params) => params?.value < 1 ? '' : (params?.value?.toFixed(1) + '%'),
                                                            },
                                                            itemStyle: {
                                                                color: "#129C83",
                                                                borderRadius: [0, 5, 5, 0],
                                                            },
                                                            //   data: [11, 15, 15, 23, 17, 27, 12, 14, 24, 13, 14, 14, 13, 12],
                                                            data: Attendance_Rate_Distribution_Dimension?.map(item => item?.PCT_ABOVE_95),
                                                        }
                                                    ]}
                                                />
                                            </LoaderContainer>
                                        </div>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                
                {/* New */}
                <div className="px-[20px] lg:px-[40px] pb-5 flex flex-col lg:flex-row  gap-4 w-full">
                    <div className="w-full lg:w-[60%] xl:w-1/2  bg-transparent flex flex-col gap-2">
                        <div className="flex flex-grow gap-2  w-full h-1/2">
                            <div className="w-1/2 bg-[#272321e6] border border-[#ffffff1a] h-full  p-3 rounded-[6px] cursor-pointer" onClick={() => { setSideBarVisible(true); HandleSelectTile('Avg Attendance Rate', Overall_Avg_Attendance_Rate?.[0]) }}>
                                <div className="w-full flex h-1/4 justify-between items-center !text-white">
                                    <div className="text-[16px] toptile_head text-[#fff] leading-[18px] w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: 'Overall average student attendance rate for the school year.' })}>Avg Attendance Rate </div>
                                    <div className="flex gap-2">
                                        <div className="text-white">{Overall_Avg_Attendance_RateCYData?.[0]?.TARGET_NUMERATOR}%</div>
                                        {Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE == 0 ?
                                            <div className="bg-[#db685b] rounded-[25px] text-[11px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                            :
                                            Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE < 0 ?
                                                <div className="bg-[#db685b] rounded-[25px] text-[11px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE?.toFixed(1)}% <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                :
                                                <div className="bg-[#129C83] rounded-[25px] text-[11px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Overall_Avg_Attendance_RateCYData?.[0]?.LAST_VARAINCE?.toFixed(1)}% <i className="pi pi-sort-up-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                        }
                                    </div>
                                </div>
                                <div className=" w-full h-3/4">
                                <LoaderContainer loading={Overall_Avg_Attendance_RateLoading} height={'100%'} width={'100%'}>
                                    <TopLinesChart
                                        tooltip={{
                                            trigger: 'item',
                                            // valueFormatter: (value) => value.toFixed(1) + '%',
                                            formatter: (params) => {
                                                return `${params?.marker} <b>${params?.name}</b>: ${params?.value?.toFixed(1)}% (${params?.data?.NUMERIC_VALUE?.toFixed(0)})`
                                            },
                                            backgroundColor: 'rgba(50,50,50,0.7)',
                                            borderColor: "#333",
                                            textStyle: {
                                                fontSize: 12,
                                                fontWeight: "normal",
                                                color: '#fff',
                                            },
                                            axisPointer: {
                                                type: 'shadow'
                                            },
                                            confine: true,
                                        }}
                                        grid={{
                                            top: '5%',
                                            left: '12%',
                                            right: '0%',
                                            bottom: '20%',
                                            // containLabel: true,
                                        }}
                                        legend={{
                                            show: false,
                                            top: 'bottom',
                                            left: 'start',
                                            data: ['Shipping', 'Avg Per Month'],
                                            textStyle: {
                                                color: '#828A91',
                                                fontSize: 8
                                            }
                                        }}
                                        xaxisdata={Overall_Avg_Attendance_Rate?.map(item => item?.SCHOOL_YEAR)}
                                        // xaxisdata={Schools_With_High_Absentees.map(item => item?.SCHOOL_OFFICIAL_NAME)}
                                        xaxisLabel={{
                                            color: '#D6D6D6',
                                            formatter: function (value) {
                                                return value.length > 5 ? value.substring(0, 5) + "..." : value;
                                            },
                                            fontSize: 12,
                                            interval: 0,
                                        }}
                                        xaxisLine={{ show: false }}
                                        xaxisTick={{ show: false }}

                                        // min={90}
                                        // max={95}
                                        // interval={10}
                                        yaxisLabel={{
                                            color: '#D6D6D6',
                                            fontSize: 12,
                                            formatter: '{value}%'
                                        }}
                                        yaxisLine={{
                                            lineStyle: {
                                                color: '#FFFFFF',
                                                type: 'dashed',
                                            },
                                        }}
                                        data={Overall_Avg_Attendance_Rate?.map(item => ({
                                            value: item?.ATTENDANCE_RATE,
                                            ...item,
                                        })
                                        )}
                                        // data={[34, 23, 20, 18, 15]}
                                        // data={Schools_With_High_Absentees.map(item => item?.METRIC_NUMERATOR)}
                                        barWidth={'80%'}
                                        itemStyle={{
                                            color: '#C79B27',
                                            borderRadius: [3, 3, 0, 0],
                                        }}
                                        label={{
                                            show: true,
                                            formatter: (params) => params.value?.toFixed(1) + '%',
                                            position: 'insideTop',
                                            color: '#fff',
                                            fontSize: 14,
                                            fontWeight: 400,
                                            padding: [0, 0, 0, 0],
                                        }}
                                        Zoom={true}
                                    />
                                    </LoaderContainer>
                                </div>
                            </div>
                            <div className="w-1/2 bg-[#272321e6] border border-[#ffffff1a] h-full  p-3 rounded-[6px] cursor-pointer" onClick={() => { setSideBarVisible(false); HandleSelectTile('Attendance Rate Distribution', Attendance_Rate_Distribution?.[0]) }} >
                                <div className="w-full flex h-1/4 justify-between items-center !text-white">
                                    <div className="text-[16px] toptile_head text-[#fff] leading-1 mb-3 capitalize w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: 'Proportion of students across different attendance rate bands for each academic year..' })}>Attendance Rate Distribution</div>
                                </div>
                                <div className=" w-full h-3/4">
                                    <LoaderContainer loading={Attendance_Rate_DistributionLoading} height={'100%'} width={'100%'}>
                                        <StackedBarChart
                                            tooltip={{
                                                trigger: 'axis',
                                                backgroundColor: 'rgba(50,50,50,0.7)',
                                                borderColor: "#333",
                                                textStyle: {
                                                    fontSize: 12,
                                                    fontWeight: "normal",
                                                    color: '#fff',
                                                },
                                                axisPointer: {
                                                    type: 'shadow'
                                                },
                                                confine: true,
                                                formatter: (params) => {
                                                    if (!params || !params.length) return "";

                                                    let tooltipContent = `<div style="margin-bottom:6px;"><b>${params[0].name}</b></div>`;

                                                    params.forEach(p => {
                                                        const pct = p.value?.toFixed(1);
                                                        const count = p.data?.count;

                                                        tooltipContent += `
                                                        <div style="display:flex;align-items:center;gap:6px;">
                                                        ${p.marker}
                                                        <span style="min-width:90px">${p.seriesName}</span>
                                                        <b>${pct}%
                                                        ${count ? `(${count})` : ""}</b>
                                                        </div>
                                                    `;
                                                    });

                                                    return tooltipContent;
                                                }
                                            }}
                                            grid={{
                                                left: "3%",
                                                right: "4%",
                                                bottom: "0%",
                                                top: "0%",
                                                containLabel: true
                                            }}
                                            legend={{
                                                data: ["<90%", "90% - 94%", ">95%"],
                                                bottom: "0",
                                                left: '0',
                                                padding: [0, 0, 0, 0],
                                                itemGap: 4,
                                                itemWidth: 7,
                                                itemHeight: 7,
                                                textStyle: {
                                                    color: '#fff',
                                                    fontSize: 10
                                                },
                                            }}
                                            xAxisData={{
                                                show: false,
                                                type: "value",
                                                max: 100,
                                                axisLine: { show: false },
                                                splitLine: { show: false },
                                            }}
                                            yAxisData={{
                                                type: "category",
                                                inverse: true,
                                                // data: ["2022", "2023", "2024"],
                                                data: Attendance_Rate_Distribution?.map(item => item?.SCHOOL_YEAR),
                                                axisLabel: {
                                                    show: true,
                                                    color: "#fff",
                                                    fontSize: 12,
                                                },
                                                axisLine: { show: false },
                                                splitLine: { show: false },
                                                axisTick: { show: false },
                                            }}
                                            series={[
                                                {
                                                    name: "<90%",
                                                    type: "bar",
                                                    stack: "total",
                                                    label: {
                                                        show: true,
                                                        position: "inside",
                                                        color: "#fff",
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        formatter: (params) => params?.value?.toFixed(1) + '%',
                                                        // formatter: "{c}%"
                                                    },
                                                    itemStyle: {
                                                        color: "#B65D59",
                                                        borderRadius: [5, 0, 0, 5],
                                                    },
                                                    // data: [56, 49, 56]
                                                    data: Attendance_Rate_Distribution?.map(item => ({
                                                        value: item?.PCT_BELOW_90,
                                                        count: item?.PCT_BELOW_90_COUNT,
                                                        ...item
                                                    }))
                                                },
                                                {
                                                    name: ">95%",
                                                    type: "bar",
                                                    stack: "total",
                                                    label: {
                                                        show: true,
                                                        position: "inside",
                                                        formatter: (params) => params?.value?.toFixed(1) + '%',
                                                        color: "#fff",
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        // formatter: "{c}%"
                                                    },
                                                    itemStyle: {
                                                        color: "#129C83" 
                                                    },
                                                    // data: [26, 26, 26]
                                                    data: Attendance_Rate_Distribution?.map(item => ({
                                                        value: item?.PCT_ABOVE_95,
                                                        count: item?.PCT_ABOVE_95_COUNT,
                                                        ...item
                                                    }))
                                                },
                                                {
                                                    name: "90% - 94%",
                                                    type: "bar",
                                                    stack: "total",
                                                    label: {
                                                        show: true,
                                                        position: "inside",
                                                        color: "#fff",
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        formatter: (params) => params?.value?.toFixed(1) + '%',
                                                        // formatter: "{c}%"
                                                    },
                                                    itemStyle: {
                                                        color: "#C79B27",
                                                        borderRadius: [0, 5, 5, 0],
                                                    },
                                                    //   data: [18, 26, 18]
                                                    data: Attendance_Rate_Distribution?.map(item => ({
                                                        value: item?.PCT_90_94,
                                                        count: item?.PCT_90_94_COUNT,
                                                        ...item
                                                    }))
                                                }
                                            ]}
                                        />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-grow gap-2  w-full h-1/2">
                            <div className="w-1/2 bg-[#272321e6] border border-[#ffffff1a] h-full  p-3 rounded-[6px] cursor-pointer" onClick={() => { setSideBarVisible(true); HandleSelectTile('% of Students Absent Days', Per_of_Students_Absent_Days?.[0]) }} >
                                <div className="w-full flex h-1/4 justify-between items-center !text-white">
                                    <div className="text-[16px] text-[#fff] toptile_head leading-1 mb-3 capitalize w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: Per_of_Students_Absent_Days?.[0]?.METRIC_DESCRIPTION })}>% of Students Absent Days</div>
                                </div>
                                <div className=" w-full h-3/4">
                                    <LoaderContainer loading={Per_of_Students_Absent_DaysLoading} height={'100%'} width={'100%'}>
                                        <ReactEcharts option={StudentAbsents} style={{ width: '100%', height: '100%' }} />;
                                    </LoaderContainer>
                                </div>
                            </div>
                            <div className="w-1/2 bg-[#272321e6] border border-[#ffffff1a] h-full  p-3 rounded-[6px] cursor-pointer" onClick={() => { setSideBarVisible(true); HandleSelectTile('Monthly Attendance Rate Trend', Monthly_Attendance_Rate_Trend?.[0]); HandleSelectTileDrp(Monthly_Attendance_Rate_Trend?.map(item => item?.MONTH)) }}>
                                <div className="w-full flex h-1/4 justify-between items-center !text-white">
                                    <div className="text-[16px] text-[#fff] toptile_head leading-[22px] mb-3 capitalize w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: Monthly_Attendance_Rate_Trend?.[0]?.METRIC_DESCRIPTION })}>Monthly Attendance Rate Trend</div>
                                </div>
                                <div className=" w-full h-3/4">
                                    <LoaderContainer loading={Monthly_Attendance_Rate_TrendLoading} height={'100%'} width={'100%'}>
                                        <SingleLineChart
                                            grid={{
                                                top: '10%',
                                                left: '12%',
                                                right: '5%',
                                                bottom: '1%',
                                                containLabel: true,
                                            }}
                                            legend={{
                                                show: false,
                                                bottom: 2,
                                                padding: [0, 0, 0, 10],
                                                left: 'start',
                                                itemGap: 4,
                                                itemWidth: 7,
                                                itemHeight: 7,
                                                textStyle: {
                                                    color: '#d6d6d6',
                                                    fontSize: 10
                                                },
                                                data: ['Days'],
                                            }}
                                            data={Monthly_Attendance_Rate_Trend}
                                        />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-full lg:w-[40%] xl:w-1/2 bg-[#272321e6] ">
                        <div className="bg-[#272321e6] rounded-[6px] border border-[#ffffff1a]">
                            <div className="px-3 py-2 text-[16px] text-[#fff] font-medium border-b border-[#ffffff1a] w-fit custom-target-icon" {...TooltipAttributes({ categorydescription: 'Proportion of students across different attendance rate bands for different student dimensions.' })}>{TabOption[activeTab]?.name} - Wise Attendance Rate Distribution</div>
                            <div className="px-4 mb-2">
                                <Tabs selectedIndex={activeTab} onSelect={handleTabClick}>
                                    <TabList>
                                        <div className="flex items-center mb-1">
                                            <Tab>
                                                <div className={`${activeTab === 0 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-bl-[5px] cursor-pointer `}>Grade</div>
                                            </Tab>
                                            <Tab>
                                                <div className={`${activeTab === 1 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] cursor-pointer `}>Ethnicity</div>
                                            </Tab>
                                            <Tab>
                                                <div className={`${activeTab === 2 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] cursor-pointer `}>Gender</div>
                                            </Tab>
                                            <Tab>
                                                <div className={`${activeTab === 3 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-br-[5px] cursor-pointer `}>School Type</div>
                                            </Tab>
                                            <Tab>
                                                <div className={`${activeTab === 4 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-br-[5px] cursor-pointer `}>Building</div>
                                            </Tab>
                                        </div>
                                    </TabList>
                                    <div className="h-[420px]">
                                        <LoaderContainer loading={Attendance_Rate_Distribution_DimensionLoading} height={'100%'} width={'100%'}>
                                            <StackedBarChart
                                                tooltip={{
                                                    trigger: 'axis',
                                                    backgroundColor: 'rgba(50,50,50,0.7)',
                                                    borderColor: "#333",
                                                    textStyle: {
                                                        fontSize: 12,
                                                        fontWeight: "normal",
                                                        color: '#fff',
                                                    },
                                                    axisPointer: {
                                                        type: 'shadow'
                                                    },
                                                    confine: true,
                                                    formatter: (params) => {
                                                        if (!params || !params.length) return "";

                                                        let tooltipContent = `<div style="margin-bottom:6px;"><b>${params[0].name}</b></div>`;

                                                        params.forEach(p => {
                                                            const pct = p.value?.toFixed(1);
                                                            const count = p.data?.count;

                                                            tooltipContent += `
                                                        <div style="display:flex;align-items:center;gap:6px;">
                                                        ${p.marker}
                                                        <span style="min-width:90px">${p.seriesName}</span>
                                                        <b>${pct}%
                                                        ${count ? `(${count})` : ""}</b>
                                                        </div>
                                                    `;
                                                        });

                                                        return tooltipContent;
                                                    }
                                                }}
                                                grid={{
                                                    left: "2%",
                                                    right: "4%",
                                                    bottom: "0%",
                                                    top: "3%",
                                                    containLabel: true
                                                }}
                                                legend={{
                                                    data: ['<90%', '90%-94%', '>95%'],
                                                    bottom: 0,
                                                    left: 'start',
                                                    padding: [0, 0, 0, 10],
                                                    itemGap: 4,
                                                    itemWidth: 7,
                                                    itemHeight: 7,
                                                    textStyle: {
                                                        color: '#E0E3E9',
                                                        fontSize: 10
                                                    },
                                                }}
                                                xAxisData={{
                                                    show: false,
                                                    type: "value",
                                                    // max: 100,
                                                    axisLine: { show: false },
                                                    splitLine: { show: false },
                                                }}
                                                yAxisData={{
                                                    type: "category",
                                                    inverse: true,
                                                    // data: [
                                                    //     'Pre-K', 'KG', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'
                                                    //   ],
                                                    data: Attendance_Rate_Distribution_Dimension?.map(item => item?.DIMENSION),
                                                    axisLabel: {
                                                        show: true,
                                                        color: "#E0E3E9",
                                                        fontSize: 12,
                                                    },
                                                    axisLine: { show: false },
                                                    splitLine: { show: false },
                                                    axisTick: { show: false },
                                                }}
                                                series={[
                                                    {
                                                        name: "<90%",
                                                        type: "bar",
                                                        stack: "total",
                                                        label: {
                                                            show: true,
                                                            position: 'inside',
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            // formatter: "{c}%"
                                                            formatter: (params) => params?.value < 1 ? '' : (params?.value?.toFixed(1) + '%'),
                                                        },
                                                        itemStyle: {
                                                            color: "#B65D59",
                                                            borderRadius: [0, 0, 0, 0],
                                                        },
                                                        // data: [65, 58, 67, 60, 66, 65, 66, 65, 56, 62, 66, 66, 65, 68],
                                                        data: Attendance_Rate_Distribution_Dimension?.map(item => ({
                                                            value:item?.PCT_BELOW_90,
                                                            count:item?.NUMERIC_VALUE_BELOW_90,
                                                            ...item
                                                        })),
                                                    },
                                                    {
                                                        name: "90%-94%",
                                                        type: "bar",
                                                        stack: "total",
                                                        label: {
                                                            show: true,
                                                            position: "inside",
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            // formatter: "{c}%"
                                                            formatter: (params) => params?.value < 1 ? '' : (params?.value?.toFixed(1) + '%'),
                                                        },
                                                        itemStyle: {
                                                            color: "#C79B27"
                                                        },
                                                        // data: [24, 27, 21, 17, 17, 22, 22, 21, 20, 25, 20, 20, 22, 20],
                                                        data: Attendance_Rate_Distribution_Dimension?.map(item => ({
                                                            value: item?.PCT_90_94,
                                                            count:item?.NUMERIC_VALUE_90_94,
                                                            ...item
                                                        })),
                                                    },
                                                    {
                                                        name: ">95%",
                                                        type: "bar",
                                                        stack: "total",
                                                        label: {
                                                            show: true,
                                                            position: "inside",
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            // formatter: "{c}%"
                                                            formatter: (params) => params?.value < 1 ? '' : (params?.value?.toFixed(1) + '%'),
                                                        },
                                                        itemStyle: {
                                                            color: "#129C83",
                                                            borderRadius: [0, 5, 5, 0],
                                                        },
                                                        //   data: [11, 15, 15, 23, 17, 27, 12, 14, 24, 13, 14, 14, 13, 12],
                                                        data: Attendance_Rate_Distribution_Dimension?.map(item => ({
                                                            value: item?.PCT_ABOVE_95,
                                                            count:item?.NUMERIC_VALUE_ABOVE_95,
                                                            ...item
                                                        })),
                                                    }
                                                ]}
                                            />
                                        </LoaderContainer>
                                    </div>
                                </Tabs>
                            </div>
                        </div>

                    </div>
                    
                </div>
                <div className="py-4 flex justify-end">
                    <div className="flex items-end">
                        <span className="text-white">Powered By </span>
                        <img src={Edvisiondarklogo} height="75px" width="150px" alt="logo" />
                    </div>
                </div>
                <AttendanceSideBar 
                    visible={isSideBarVisible}
                    onHide={() => setSideBarVisible(false)}
                    data={[sideBarData, setSideBarData]}
                    DropdownData={[dropdownData, setDropdownData]}
                />
                <AttendanceSideBar2 
                    visible={isSideBar2Visible}
                    onHide={() => setSideBar2Visible(false)}
                />

                <AttendanceBottomBar
                    visible={isBottomBarVisible}
                    onHide={() => setBottomBarVisible(false)}
                    title={selectedTitle}
                />    
                <AttendanceBottomBar1
                    visible={isBottomBar1Visible}
                    onHide={() => setBottomBar1Visible(false)}
                    title={selectedTitle}
                />
                <AttendanceBottomBar2
                    visible={isBottomBar2Visible}
                    onHide={() => setBottomBar2Visible(false)}
                    title={selectedTitle}
                />    
            </div>
        </>
    )
}